var map = {
	"./activity.svg": "6736",
	"./add-order-b.svg": "0fdc",
	"./add-order-h.svg": "2e9c",
	"./adviser-b.svg": "b64c",
	"./adviser-h.svg": "01d4",
	"./agent-task.svg": "84c2",
	"./appraiser.svg": "8450",
	"./approval.svg": "eaef",
	"./assay.svg": "3b91",
	"./assess-price.svg": "7a40",
	"./authority.svg": "b203",
	"./basics-goods-bai.svg": "f575",
	"./basics-goods-hei.svg": "d8ed",
	"./calculator.svg": "879a",
	"./clean-b.svg": "4e2a",
	"./clean-h.svg": "ffeb",
	"./clientelechannel.svg": "f74c",
	"./clientelelabel.svg": "8998",
	"./clientelestate.svg": "ec3e",
	"./customerBind.svg": "a096",
	"./customerManage.svg": "d8b9",
	"./cz-select.svg": "7472",
	"./cz-shopmall.svg": "ce92",
	"./cz-tags-type.svg": "aa5d",
	"./cz-tags.svg": "4bfd",
	"./damuge-bai.svg": "9e2a",
	"./damuge-hei.svg": "ce54",
	"./damuge.svg": "ec05",
	"./dashboard-bai.svg": "cbfb",
	"./dashboard-hei.svg": "daf5",
	"./depart.svg": "bba7",
	"./downloads.svg": "9698",
	"./editPage_active_list.svg": "7d98",
	"./editPage_coupon_coupon.svg": "7a2b",
	"./editPage_coupon_couponApply.svg": "6aff",
	"./editPage_list.svg": "56d7",
	"./editPage_sucai.svg": "596e",
	"./editPage_wrap.svg": "84d2",
	"./emotion.svg": "0718",
	"./example.svg": "30c3",
	"./export-hei.svg": "de62",
	"./eye.svg": "4df5",
	"./feedback-b.svg": "597c",
	"./feedback-h.svg": "eb61",
	"./finance-a.svg": "9ac9",
	"./finance-bounty.svg": "30a6",
	"./finance-card.svg": "2ca4",
	"./finance-commission.svg": "8f1e",
	"./finance-dakuan.svg": "0ebc",
	"./finance-settlement.svg": "dc8a",
	"./finance-verify.svg": "3478",
	"./form.svg": "eb1b",
	"./goods-b.svg": "3304",
	"./goods-h.svg": "1cad",
	"./goods-search.svg": "9a94",
	"./group.svg": "a75f",
	"./huishou-b.svg": "3eb1",
	"./huishou-h.svg": "d994",
	"./huopinguanli-b.svg": "96b0",
	"./huopinguanli-h.svg": "2087",
	"./huoweizhuanyi-b.svg": "e409",
	"./huoweizhuanyi-h.svg": "005a",
	"./identificationTool.svg": "13db",
	"./inbound.svg": "c003",
	"./jd.svg": "16e7",
	"./jdGoods.svg": "6611",
	"./jdProps.svg": "e79b",
	"./jianding-b.svg": "f9ad",
	"./jianding-h.svg": "962d",
	"./jiandingdashi.svg": "6088",
	"./jianhuo-b.svg": "6b51",
	"./jianhuo-h.svg": "d31d",
	"./kucun-hei.svg": "3699",
	"./library.svg": "90a0",
	"./list-b.svg": "6d0f",
	"./list-h.svg": "f974",
	"./logs.svg": "06a8",
	"./menu.svg": "bd3d",
	"./merge.svg": "1c8d",
	"./order-list-b.svg": "cc7b",
	"./order-list-h.svg": "3f23",
	"./outboundOrder.svg": "257f",
	"./password.svg": "2a3d",
	"./phone.svg": "dd82",
	"./printer.svg": "c571",
	"./rationality-b.svg": "2754",
	"./rationality-h.svg": "e38e",
	"./role.svg": "520c",
	"./rollback.svg": "e702",
	"./ruku-b.svg": "7516",
	"./ruku-h.svg": "fdbf8",
	"./rule.svg": "38fb",
	"./setting.svg": "05ff",
	"./shelves.svg": "25d5",
	"./shift-logs.svg": "0933",
	"./shot-b.svg": "143b",
	"./shot-h.svg": "a916",
	"./sidebar-setting.svg": "97c0",
	"./sourceChannel.svg": "1a9f",
	"./speech.svg": "062e",
	"./statistics-b.svg": "e2607",
	"./statistics-h.svg": "3276",
	"./stockGoodsImage.svg": "89fd",
	"./supply-chain-b.svg": "f4e0",
	"./supply-chain-h.svg": "b5b5",
	"./sync-bai.svg": "03eb",
	"./sync-goods-bai.svg": "6377",
	"./sync-goods-hei.svg": "0e68",
	"./sync-hei.svg": "40fa",
	"./table.svg": "47f1",
	"./timelineStatistics.svg": "3482",
	"./tradein.svg": "84ce",
	"./tree.svg": "93cd",
	"./tuihui-h.svg": "6d4b",
	"./tuihuo-h.svg": "906e",
	"./unknownPackage.svg": "4f53",
	"./user-admin-bai.svg": "be99",
	"./user-admin.svg": "a09b",
	"./user-bai.svg": "6926",
	"./user-hui.svg": "30bb",
	"./user.svg": "b3b5",
	"./userConfirmation-b.svg": "5bd2",
	"./userConfirmation-h.svg": "96e4",
	"./virtual.svg": "330c",
	"./weixin.svg": "5afe",
	"./wishList.svg": "c156",
	"./wms-b.svg": "ed40",
	"./wms-h.svg": "ec6d",
	"./xiaoshou-b.svg": "b0ee",
	"./xiaoshou-h.svg": "e28e",
	"./yz-gift.svg": "3d57",
	"./yz-tag.svg": "9b0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";